import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { cropAfterDecimals } from 'helpers/utils';

import { ScalpingStore } from './scalping.types';

const useScalpingStoreBase = create<ScalpingStore>()(
  devtools(
    set => ({
      // #region States
      state: {
        latestCommissionRebate: null,
        totalCommissionRebate: null,
      },

      // #endregion

      // #region Actions
      actions: {
        resetScalpingStore: () => {
          set(
            state => ({
              ...state,
              state: {
                latestCommissionRebate: null,
                totalCommissionRebate: null,
              },
            }),
            false,
            'resetScalpingStore'
          );
        },
        updateScalpingRebateAmount: ({
          latestCommissionRebate,
          totalCommissionRebate,
        }: {
          latestCommissionRebate: string;
          totalCommissionRebate: string;
        }) => {
          set(
            state => ({
              ...state,
              state: {
                latestCommissionRebate: cropAfterDecimals(
                  Number(latestCommissionRebate),
                  2
                ),
                totalCommissionRebate: cropAfterDecimals(
                  Number(totalCommissionRebate),
                  2
                ),
              },
            }),
            false,
            'updateScalpingRebateAmount'
          );
        },
      },

      // #endregion
    }),
    {
      name: 'ScalpingStore',
    }
  )
);

export { useScalpingStoreBase };
